// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-components-asset-list-js": () => import("./../../../src/pages/components/AssetList.js" /* webpackChunkName: "component---src-pages-components-asset-list-js" */),
  "component---src-pages-components-matrix-js": () => import("./../../../src/pages/components/Matrix.js" /* webpackChunkName: "component---src-pages-components-matrix-js" */),
  "component---src-pages-components-result-js": () => import("./../../../src/pages/components/Result.js" /* webpackChunkName: "component---src-pages-components-result-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

